import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import EventForm from "./EventForm";
import EventListView from "./EventListView";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import { createEvent, loadUserEvents } from "../../redux/actions/eventActions";
import Spinner from "../common/Spinner";
import moment from "moment"
import $ from 'jquery';
import "./Event.css";

function EventSearch({
    allowEventCreation,
    identifyGroups,
    user,
    route,
    routes,
    groups,
    group,
    events,
    createEvent,
    loadUserEvents,
    history
}) {

    const [eventDetails, setEventDetails] = useState({ name: "", location: "", description: "", routeId: null, startDate: new Date(), finishDate: null, organiser: {}, participants: [] });
    const [targetEvents, setTargetEvents] = useState(null);
    const [errors, setErrors] = useState({});
    const [activeView, setActiveView] = useState({ view: "list" });
    const [processing, setProcessing] = useState(true);
    const [calendarKey, setCalendarKey] = useState([]);
    const eventColours = ["#FF7C1F", "#92D050", "#B14AFF", "#91B8C1", "#FFC510", "#00B0F0", "#FFACF5", "#8FAADC", "#A2EDF0", "#A6D2DD"];

    useEffect(() => {

        //load events

        loadUserEvents()
            .then(events => {

                //FILTER BY GROUP ERE!!! 
                if (group) {
                    var filteredEvents = [];
                    events.map(e => {
                        if (e.groupId == group.id) {
                            filteredEvents.push(e);
                        }
                    })
                    setUpCalendarKeys(filteredEvents)
                    setTargetEvents(filteredEvents);
                } else {
                    setUpCalendarKeys(events)
                    setTargetEvents(events);
                }
                
                setProcessing(false);
            });

        //set up new event form for route/group selection

        if (route) {
            setEventDetails(prevEventDetails => ({
                ...prevEventDetails,
                routeId: route.routeId
            }));
        } 

        if (group) {
            setEventDetails(prevEventDetails => ({
                ...prevEventDetails,
                groupId: group.id,
                groupName: group.name,
                groupHasAvatar: group.avatarAvailable
            }));
        }

        
        
    }, []);

    function setUpCalendarKeys(events) {
        var groupsKey = [];
        var groupsKeyIndex = 0;

        events.map(e => {
            var colour = null;
            groupsKey.map(key => {
                if (key.id == e.groupId) {
                    colour = key.colour;
                }
            })
            if (!colour) {
                groupsKey.push({ id: e.groupId, name: e.groupName, colour: eventColours[groupsKeyIndex] })
                groupsKeyIndex++;
            }
        })

        setCalendarKey(groupsKey);
    }

    function setView(e) {
        e.preventDefault();
        var view = e.target.title;
        setActiveView(setActiveView => ({
            ...setActiveView,
            view: view
        }));
    }

    function getCalendarEvents() {

        var results = [];

        targetEvents.map(e => {
            var colour = null;
            calendarKey.map(key => {
                if (key.id == e.groupId) {
                    colour = key.colour; 
                }
            })

            var event = {
                id: e.id,
                title: e.name,
                start: e.startDate,
                end: e.finishDate,
                classNames: ["calendar-event"],
                backgroundColor: colour,
                borderColor: colour
            }
            results.push(event);
        })

        return results; 
    }

    function handleEventClick(e) {
        history.push(`/events/${e.event.id}`)
    }

    function handleChange(e) {
        var { name, value } = e.target;

        setErrors(prevErrors => ({
            ...prevErrors,
            [name] : null
        }))

        if (name == "routeId") {
            setEventDetails(prevEventDetails => ({
                ...prevEventDetails,
                route: { id: value, name: getRouteName(value) },
                routeId: value
            }));
            return;
        }

        if (name == "startDate" && eventDetails.finishDate == null) {
            setEventDetails(prevEventDetails => ({
                ...prevEventDetails,
                finishDate: moment(value).add(2, 'h').toDate(),
                startDate: value
            }));
            return;
        }

        setEventDetails(prevEventDetails => ({
            ...prevEventDetails,
            [name]: value
        }));
    }

    function handleSave(e) {
        e.preventDefault();
      
        if (!formIsValid()) {
            return;
        }

        eventDetails.organiser = { userId: user.id, firstName: user.firstName, surname: user.surname, hasAvatar: user.avatarAvailable }
        eventDetails.participants = [{ userId: user.id, firstName: user.firstName, surname: user.surname, hasAvatar: user.avatarAvailable, status: 0 }]

        $('#newEvent').modal('hide')
        setProcessing(true);

        createEvent(eventDetails)
            .then((event) => {
                setProcessing(false);
                
                toast.success(`Event Created: ${event.name}`);
                history.push(`/events/${event.id}`);
            })
            .catch(error => {
                setProcessing(false);
                $('#newEvent').modal('show')
                setErrors({ onSave: error.message });
            });
    }

    function formIsValid() {
        const errors = {};
        var isValid = true;

        if (!eventDetails.name) {
            errors.name = "An event title is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!eventDetails.location) {
            errors.location = "A location is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!eventDetails.routeId) {
            errors.route = "A route is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!eventDetails.description) {
            errors.description = "A description is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!moment(eventDetails.finishDate).isSameOrAfter(eventDetails.startDate)) {
            errors.finishDate = "End date must be after the start date!";
            setErrors(errors);
            isValid = false;
        }

        return isValid;
    }

    function handleCancelSave(e) {
        e.preventDefault();
        $('#newEvent').modal('hide')
    }

    function getRouteName(id) {
        var name;
        if (group.sharedRoutes) {
            group.sharedRoutes.map(route => {
                if (route.routeId == id) name = route.routeName
            })
        }
        return name;
    }

    return (
                
            <div className="group-search col-12">
                <div className="search-toolbar top-form">
                    <div className="input-group">
                        <div className="btn-group btn-group-toggle event-view-toggle" data-toggle="buttons">
                            <button title="calendar" className={activeView.view == "calendar" ? "btn btn-secondary btn-sm active" : "btn btn-secondary btn-sm"} onClick={setView}>
                                <span title="calendar" className="far fa-calendar-alt mr-1"></span>
                            </button>
                            <button title="list" className={activeView.view == "list" ? "btn btn-secondary btn-sm active" : "btn btn-secondary btn-sm"} onClick={setView}>
                                <span title="list" className="fas fa-list mr-1"></span>
                            </button>
                            {allowEventCreation ?
                                <button className="btn btn-sm btn-info" data-toggle="modal" data-target="#newEvent">
                                    <span className="fas fa-plus mr-1"></span>Organise Event
                                </button>
                                : "" } 
                        </div>
                    </div>
                </div>
                {processing ?
                <Spinner /> :
                <div className="event-view-panel">
                    
                        {
                            (() => {
                                switch (activeView.view) {
                                    case "calendar":
                                        return (
                                            <div className="row justify-content-center mb-5">
                                                <div className="col-10 mb-5">
                                                    {!group &&
                                                        <ul className="calendarKey">
                                                            {calendarKey.map(key => {
                                                                return (
                                                                    <li key={key.id} className="keyItem">
                                                                        <div className="keyColour" style={{ backgroundColor: key.colour }}></div>
                                                                        <div className="keyLabel">{key.name}</div>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    }
                                                    <FullCalendar
                                                        defaultView="dayGridMonth"
                                                        eventClick={handleEventClick}
                                                        plugins={[dayGridPlugin, interactionPlugin]}
                                                        events={getCalendarEvents()}
                                                        eventColor={"#91B8C1"}
                                                        eventTextColor={"#fff"}
                                                        displayEventTime={false}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    case 'list':
                                        return (
                                            <EventListView events={targetEvents} identifyGroups={identifyGroups} />
                                        )
                                    default:
                                        return null;
                                }
                            })()
                        }

                
                    {allowEventCreation &&
                        <div className="modal fade" id="newEvent" tabIndex="-1" role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                        <h5 className="modal-title">Create a New Event</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <EventForm
                                            event={eventDetails}
                                            groups={!group ? groups : null}
                                            routes={!route ? routes : null}
                                            onChange={handleChange}
                                            onSave={handleSave}
                                            onCancel={handleCancelSave}
                                            saving={processing}
                                            errors={errors}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                }
            </div>
    );

}

EventSearch.propTypes =
{
    allowEventCreation: PropTypes.bool,
    identifyGroups: PropTypes.bool,
    user: PropTypes.object.isRequired,
    group: PropTypes.object,
    groups: PropTypes.object.isRequired,
    events: PropTypes.array.isRequired,
    route: PropTypes.object,
    createEvent: PropTypes.func.isRequired,
    loadUserEvents: PropTypes.func.isRequired,
    errorMessage: PropTypes.string
}


function mapStateToProps(state) {
    return {
        user: state.user,
        events: state.events,
        groups: state.groups
    };
}

const mapDispatchToProps = {
    createEvent,
    loadUserEvents
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventSearch)); 


// WEBPACK FOOTER //
// ./src/components/events/EventSearch.js